export enum SchoolStatus {
	Pending = 'pending',
	Approved = 'approved',
	Denied = 'denied'
}